import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getActivityLogs } from '../../../services/services';

export const getActivityLogsData = createAsyncThunk(
	'getLogs',
	async ({ page, limit, search } = {}, thunkAPI) => {
		try {
			const response = await getActivityLogs({ page, limit, search });
			return response?.data;
		} catch (error) {
			return thunkAPI.rejectWithValue(error.response?.data || error.message);
		}
	},
);

const activityLogsSlice = createSlice({
	name: 'activityLogsSlice',
	initialState: {
		logsData: null,
		isLoading: false,
		isError: null,
	},
	extraReducers: (builder) => {
		builder
			.addCase(getActivityLogsData.pending, (state) => {
				state.isLoading = true;
				state.isError = null;
			})
			.addCase(getActivityLogsData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.logsData = action.payload;
				state.isError = null;
			})
			.addCase(getActivityLogsData.rejected, (state, action) => {
				state.isLoading = false;
				state.logsData = null;
				state.isError = action.payload;
			});
	},
});

export default activityLogsSlice.reducer;
